import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ROUTE } from './types'

import LoadingSpinner from '@/components/common/LoadingSpinner'
import ProgressBar from '@/components/common/ProgressBar'
import { isDingTalkEnvironment } from '@/utils/dingtalk'

const Loading: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      if (isDingTalkEnvironment()) {
        navigate(ROUTE.FREE)
      } else {
        navigate(ROUTE.OAUTH)
      }
    }, 500)
  }, [])

  return (
    <>
      {/* 加载进度条 */}
      <ProgressBar
        visible={true}
        height="sm"
        color="blue"
        animation="shimmer"
        className="absolute top-0 left-0 right-0 z-10"
      />
      <LoadingSpinner
        className="p-20"
        fullScreen={false}
        text="登陆环境检测中..."
      />
    </>
  )
}

export default Loading
